import ConfirmModal from '../../../../common/ConfirmModal';

type EditEmailWarningModalProps = {
  id: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const EditEmailWarningModal = ({
  id,
  isOpen,
  onClose,
  onConfirm,
}: EditEmailWarningModalProps) => (
  <ConfirmModal
    body="Are you sure you want to edit this user's email address? This will update their Equip app login credentials and send a reset password email to the new email address."
    cancelLabel="Back to editing"
    confirmLabel="Confirm email change"
    confirmVariant="accent.critical"
    id={`edit-family-user-email_${id}`}
    isOpen={isOpen}
    onClose={onClose}
    onConfirm={onConfirm}
    title="Updating user email"
  />
);

export default EditEmailWarningModal;
